import { createListenerMiddleware } from "@reduxjs/toolkit";

import authService from "./auth";
import contentService from "./content";
import paymentService from "./payment";

const listenerMiddleware = createListenerMiddleware();

const bindListener = (listener: any) => {
	listener((actionCreator: any, effect: any) => {
		listenerMiddleware.startListening({
			actionCreator,
			effect,
		});
	});
};

// listen middleware
bindListener(authService);
bindListener(contentService);
bindListener(paymentService);
// bindListener(shipmentService)
// bindListener(foregroundTask)

export default listenerMiddleware;
